import { Facebook, Twitter, Youtube, Send, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

export const TopBar = () => {
  const { settings: s } = useSettings();
  const date = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  const socials = [
    [Facebook, s.facebook_url, "facebook"],
    [Twitter, s.twitter_url, "twitter"],
    [Youtube, s.youtube_url, "youtube"],
    [Send, s.telegram_url, "telegram"],
    [MessageCircle, s.whatsapp_number ? `https://wa.me/${s.whatsapp_number.replace(/\D/g, "")}` : "", "whatsapp"],
  ].filter(([, href]) => href);
  return (
    <div className="bg-[#0B0F19] text-zinc-300 text-xs">
      <div className="container-site flex items-center justify-between h-9">
        <div className="flex items-center gap-3">
          <span data-testid="top-bar-date" className="capitalize">{date}</span>
          <span className="hidden sm:inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider bg-red-600 text-white px-1.5 py-0.5">FR · RDC</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/a-propos" className="hidden sm:inline hover:text-white transition-colors">À propos</Link>
          <Link to="/a-propos/equipe" className="hidden sm:inline hover:text-white transition-colors">Équipe</Link>
          <div className="flex items-center">
            {socials.map(([Icon, href, name]) => (
              <a key={name} href={href} target="_blank" rel="noreferrer" aria-label={name} data-testid={`social-${name}`} className="w-9 h-9 flex items-center justify-center border-l border-white/10 hover:bg-red-600 hover:text-white transition-colors">
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
